"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _pageHeader = _interopRequireDefault(require("@atlaskit/page-header"));
var _styles = require("@material-ui/styles");
var _useMeasure3 = _interopRequireDefault(require("react-use/lib/useMeasure"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Line = _interopRequireDefault(require("../Line/Line"));
var _TabList = _interopRequireDefault(require("../Tabs/TabList"));
var _Grid = _interopRequireDefault(require("../../Grid/Grid"));
var _Text = require("../../Text/Text");
var _ModalView = require("../../View/ModalView/ModalView");
var _colors = require("../../style/colors");
var _PageHeaderButtonGroup = _interopRequireDefault(require("./PageHeaderButtonGroup"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  var rowLayoutBreakpoint = theme.breakpoints.gte.tablet.portrait;
  var stickyHeaderStyles = {
    zIndex: theme.zIndex.modal,
    position: 'absolute',
    marginRight: '-.5rem',
    marginLeft: '-.5rem',
    paddingRight: '.5rem',
    // Offset margin-right
    paddingLeft: '.5rem',
    // Offset margin-left
    backgroundColor: theme.colors.white,
    right: theme.functions.toRem(theme.variables.modalMobilePadding),
    left: theme.functions.toRem(theme.variables.modalMobilePadding)
  };
  return {
    actionsWrapperElement: (0, _defineProperty2.default)({
      alignSelf: 'center',
      paddingLeft: 0
    }, theme.breakpoints.lt.tablet.portrait, {
      width: '100%'
    }),
    badge: (0, _defineProperty2.default)({
      display: 'block',
      '& > *': {
        verticalAlign: 'middle'
      }
    }, rowLayoutBreakpoint, {
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: '.5rem',
      '& > *': {
        verticalAlign: 'baseline' // Reset vertical-align
      }
    }),
    button: {
      flexGrow: 1
    },
    favorite: (0, _defineProperty2.default)({
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: '.5rem',
      '& > *': {
        verticalAlign: 'middle'
      }
    }, rowLayoutBreakpoint, {
      '& > *': {
        verticalAlign: 'baseline' // Reset vertical-align
      }
    }),
    header: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, (0, _defineProperty2.default)({}, rowLayoutBreakpoint, {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      height: '2.25rem'
    })),
    hidden: {
      display: 'none'
    },
    line: function line(props) {
      return props.disableStickyHeader === 'mobile' ? (0, _defineProperty2.default)({}, rowLayoutBreakpoint, {
        marginBottom: 0
      }) : {
        marginBottom: 0
      };
    },
    pageHeader: {
      // Reset Outer styles in the context of a modal
      // https://bitbucket.org/atlassian/atlaskit-mk-2/src/be4cdd0b1f9566847c274d0d05b9549881e0ae4a/packages/core/page-header/src/PageHeader/styled.ts?at=master#lines-18
      marginTop: '-24px'
    },
    shadowDiv: function shadowDiv(props) {
      return props.disableStickyHeader === 'mobile' ? (0, _defineProperty2.default)({}, theme.breakpoints.lte.tablet.portrait, {
        display: 'none'
      }) : {};
    },
    stickyHeader: function stickyHeader(props) {
      return _objectSpread(_objectSpread({}, props.disableStickyHeader === 'mobile' ? (0, _defineProperty2.default)({}, rowLayoutBreakpoint, stickyHeaderStyles) : stickyHeaderStyles), {}, (0, _defineProperty2.default)({}, theme.breakpoints.desktop, {
        right: theme.functions.toRem(theme.variables.modalDesktopPadding),
        left: theme.functions.toRem(theme.variables.modalDesktopPadding)
      }));
    },
    subTitle: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
      minWidth: 0,
      // Reset BottomBarWrapper styles
      // https://bitbucket.org/atlassian/atlaskit-mk-2/src/be4cdd0b1f9566847c274d0d05b9549881e0ae4a/packages/core/page-header/src/PageHeader/styled.ts?at=master#lines-55
      marginTop: '-16px'
    }),
    subTitlePadding: {
      paddingBottom: '1rem'
    },
    subTitleText: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      color: theme.colors.pebbleGrey
    }),
    title: (0, _defineProperty2.default)({
      marginRight: '.5rem'
    }, rowLayoutBreakpoint, _objectSpread({}, theme.mixins.truncate)),
    titleContainerElement: (0, _defineProperty2.default)({}, rowLayoutBreakpoint, {
      flexGrow: 1,
      flexBasis: 0
    })
  };
});
var addClassToParentElement = function addClassToParentElement(node, className /*: string*/) {
  var _node$parentElement;
  // Support optional chaining (https://github.com/facebook/flow/issues/4303)
  // $FlowIgnore
  return node === null || node === void 0 ? void 0 : (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.classList.add(className);
};
/*:: type BreadcrumbType = React.Element<any> | boolean | null;*/
/*:: type ButtonInputType = React.Element<any> | null;*/
// typeof Breadcrumb
/*:: type MenuType = React.Element<any>;*/
// typeof ButtonInput
/*:: type SubTitle = React.Node;*/
// typeof Menu
// It would be nice if...
// ```
// type SubTitle =
// | string
// | React.Element<typeof FormattedMessage>
// | React.Element<typeof Markdown>;
// ```
// but `StepListHeader.js` and `GalleryDetail.js` requires a `React.Node` type
/*:: type Title =
  | string
  | React.Element<typeof FormattedMessage>
  | React.Element<typeof Link>;*/
/*:: type Props = {|
  badge?: React.Node,
  breadcrumb?: BreadcrumbType,
  buttons?: ButtonInputType | Array<ButtonInputType>,
  children?: React.Node,
  disableModalBreadcrumb?: boolean,
  disableStickyHeader?: boolean | 'mobile',
  favorite?: React.Node,
  includeLine?: boolean,
  menu?: MenuType,
  subTitle?: SubTitle,
  subTitleClassName?: string,
  tabs?: React.Element<typeof TabList>,
  title?: Title
|};*/
function PageHeader(_ref4 /*:: */) {
  var badge = _ref4 /*:: */.badge,
    breadcrumb = _ref4 /*:: */.breadcrumb,
    buttons = _ref4 /*:: */.buttons,
    children = _ref4 /*:: */.children,
    _ref4$disableModalBre = _ref4 /*:: */.disableModalBreadcrumb,
    disableModalBreadcrumb = _ref4$disableModalBre === void 0 ? false : _ref4$disableModalBre,
    disableStickyHeader = _ref4 /*:: */.disableStickyHeader,
    favorite = _ref4 /*:: */.favorite,
    _ref4$includeLine = _ref4 /*:: */.includeLine,
    includeLineProp = _ref4$includeLine === void 0 ? false : _ref4$includeLine,
    menu = _ref4 /*:: */.menu,
    subTitle = _ref4 /*:: */.subTitle,
    subTitleClassName = _ref4 /*:: */.subTitleClassName,
    tabsProp = _ref4 /*:: */.tabs,
    title = _ref4 /*:: */.title;
  var classes = useStyles({
    disableStickyHeader: disableStickyHeader
  });
  var theme = (0, _styles.useTheme)();
  var modalViewContext = React.useContext(_ModalView.ModalViewContext);
  var shouldApplyStickyHeaderStyles = typeof disableStickyHeader === 'boolean' ? !disableStickyHeader : modalViewContext;
  var shouldRenderBreadcrumb = !disableModalBreadcrumb || !modalViewContext;
  var includeLine = includeLineProp !== null && includeLineProp !== void 0 ? includeLineProp : modalViewContext && !tabsProp;
  var lineClassName = (0, _classnames.default)((0, _defineProperty2.default)({}, classes.line, shouldApplyStickyHeaderStyles));
  var _useMeasure = (0, _useMeasure3.default)(),
    _useMeasure2 = (0, _slicedToArray2.default)(_useMeasure, 2),
    ref = _useMeasure2[0],
    height = _useMeasure2[1].height;
  var _ref5 = Array.isArray(buttons) ? buttons : [buttons],
    _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
    primaryButtonProp = _ref6[0],
    secondaryButtonProp = _ref6[1];
  var primaryButton = primaryButtonProp != null ? React.cloneElement(primaryButtonProp, {
    className: classes.button,
    colorScheme: _colors.SCIENCE_BLUE
  }) : null;
  var secondaryButton = primaryButton && secondaryButtonProp != null ? React.cloneElement(secondaryButtonProp, {
    className: classes.button,
    invertScheme: true,
    colorScheme: _colors.BLACK
  }) : null;
  var tabs = tabsProp != null ? React.cloneElement(tabsProp, {
    className: lineClassName
  }) : null;
  var actionsElement = React.useCallback(function (node) {
    addClassToParentElement(node, classes.actionsWrapperElement);
  }, [classes]);
  var childrenElement = React.useCallback(function (node) {
    addClassToParentElement(node, classes.titleContainerElement);
  }, [classes]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: shouldApplyStickyHeaderStyles ? classes.stickyHeader : undefined,
    "data-testid": "page-header",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: modalViewContext ? classes.pageHeader : undefined
  }, /*#__PURE__*/React.createElement(_pageHeader.default, {
    actions: (primaryButton || menu) && /*#__PURE__*/React.createElement(_PageHeaderButtonGroup.default, {
      "data-testid": "page-header-button-group",
      ref: actionsElement
    }, primaryButton, secondaryButton, menu),
    bottomBar: (subTitle || children) && /*#__PURE__*/React.createElement(_Grid.default, {
      container: true,
      direction: "column"
    }, subTitle && /*#__PURE__*/React.createElement(_Grid.default, {
      className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.subTitlePadding, Boolean(children))),
      item: true,
      xs: true,
      md: 11,
      zeroMinWidth: true
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.subTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(classes.subTitleText, subTitleClassName)
    }, subTitle))), /*#__PURE__*/React.createElement("div", null, children)),
    breadcrumbs: shouldRenderBreadcrumb ? breadcrumb : undefined,
    disableTitleStyles: true,
    truncateTitle: false
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.hidden,
    ref: childrenElement
  }), /*#__PURE__*/React.createElement(_Text.Header1, {
    className: classes.header
  }, title && /*#__PURE__*/React.createElement("span", {
    className: classes.title,
    title: typeof title === 'string' ? title : undefined
  }, title), favorite && /*#__PURE__*/React.createElement("span", {
    className: classes.favorite
  }, favorite), badge && /*#__PURE__*/React.createElement("span", {
    className: classes.badge
  }, badge)))), includeLine && /*#__PURE__*/React.createElement(_Line.default, {
    className: lineClassName
  }), tabs), shouldApplyStickyHeaderStyles &&
  /*#__PURE__*/
  // Shadow `div` pushes down modal content
  // when page header is fixed
  React.createElement("div", {
    className: classes.shadowDiv,
    role: "presentation",
    style: {
      height: height + parseInt(theme.variables.base)
    }
  }));
}
PageHeader.displayName = 'PageHeader';
var _default = exports.default = PageHeader;
//# sourceMappingURL=PageHeader.js.map